<template>
  <div
    class="personal-center_hc"
    :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'"
  >
    <ul class="nav_tabs">
      <li
        v-for="(item, index) in tabs"
        :key="index"
        :class="checkedID === index ? 'checkedClass' : ''"
        @click="handleClickTabs(index)"
      >
        {{ item }}
      </li>
    </ul>

    <p class="census">共{{ countData }}个</p>

    <ul class="hc_card" ref="cardList">
      <li v-for="(item, index) in listData" :key="index" @click="goDetails(item.h_id)">
        <img src="../../assets//image/zdtype.png" alt="" class="zdtype" v-if="item.sort_top" />
        <div class="top">
          <div class="top_left">
            {{ checkedID ? '量化交易策略回测' : '多因子回测' }}{{ item.index_info }}
            <span class="underway" v-if="item.mn_status">模拟盘进行中</span>
          </div>

          <van-icon
            name="ellipsis"
            class="dian"
            @click.stop="
              handleCliakActionSheet(
                item.h_id,
                index,
                item.sort_top,
                item.mn_status,
                item.chigu_cycle,
                item.MaxYearCycle,
                item.sortKind
              )
            "
          />
        </div>

        <div class="residue">
          <p class="van-ellipsis">
            <span v-for="(item2, index2) in item.f_name_arr.split(',')" :key="index2"
              >{{ item2 }}<span v-if="index2 !== item.f_name_arr.split(',').length - 1">,</span>
            </span>
          </p>
          <p class="num" v-if="item.f_name_arr.split(',').length > 4">
            {{ item.f_name_arr.split(',').length }}个
          </p>
        </div>

        <div class="card">
          <van-row gutter="4">
            <van-col span="8">
              <div class="block">
                <p class="b_p1 van-multi-ellipsis--l2" style="height: 1.1rem">
                  {{ item.chigu_cycle }}天
                </p>
                <p class="b_p3">持股周期</p>
              </div>
            </van-col>
            <van-col span="8" v-if="checkedID === 0">
              <div class="block">
                <p class="b_p1">持股{{ item.avg_profit_cycle }}天</p>
                <p class="b_p2" :class="judgeColor(item.avg_profit_zf)">
                  {{ toFixedNum(item.avg_profit_zf * 100, 2, '%') }}
                </p>
                <p class="b_p3">最优平均涨幅</p>
              </div>
            </van-col>
            <van-col span="8" v-if="checkedID === 0">
              <div class="block">
                <p class="b_p1">持股{{ item.win_rate_cycle }}天</p>
                <p class="b_p2" :class="judgeColor(item.win_rate_zf)">
                  {{ toFixedNum(item.win_rate_zf * 100, 2, '%') }}
                </p>
                <p class="b_p3">最大上涨概率</p>
              </div>
            </van-col>

            <van-col span="8" v-if="checkedID === 1">
              <div class="block">
                <p class="b_p1">持股{{ item.MaxYearCycle }}天</p>
                <p class="b_p2" :class="judgeColor(item.MaxYearProfit)">
                  {{ toFixedNum(item.MaxYearProfit * 100, 2, '%') }}
                </p>
                <p class="b_p3">预估年化收益</p>
              </div>
            </van-col>
            <van-col span="8" v-if="checkedID === 1">
              <div class="block">
                <p class="b_p1">持股{{ item.MaxSuccessCycle }}天</p>
                <p class="b_p2" :class="judgeColor(item.MaxSuccessRate)">
                  {{ toFixedNum(item.MaxSuccessRate * 100, 2, '%') }}
                </p>
                <p class="b_p3">最大成功率</p>
              </div>
            </van-col>
          </van-row>
        </div>

        <div class="bottom_time">
          <van-row>
            <van-col span="12">
              <p class="label">开始时间:</p>
            </van-col>
            <van-col span="12">
              <p class="content">{{ dateFormat('YYYY-MM-DD', item.starDate) }}</p>
            </van-col>
          </van-row>

          <van-row>
            <van-col span="12">
              <p class="label">结束时间:</p>
            </van-col>
            <van-col span="12">
              <p class="content">{{ dateFormat('YYYY-MM-DD', item.endDate) }}</p>
            </van-col>
          </van-row>

          <van-row>
            <van-col span="12">
              <p class="label">回测时间:</p>
            </van-col>
            <van-col span="12">
              <p class="content">{{ item.backtest_td }}</p>
            </van-col>
          </van-row>
        </div>
      </li>

      <p class="isNoMoreValue" v-if="listData.length">没有更多了</p>

      <van-empty
        :description="description"
        v-show="!listData.length"
        :image="require('@/assets/image/notData.png')"
      />
    </ul>

    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
      @select="onSelect"
    />

    <van-overlay :show="showoVerlay">
      <div class="wrapper-overlay" @click.stop>
        <van-form @submit="saveMnjy">
          <p class="wrapper-title">创建量化模拟交易</p>

          <p class="wrapper-label">模拟交易名称</p>
          <div class="name">
            <van-field
              v-model="mnjyName"
              autosize
              maxlength="10"
              show-word-limit
              placeholder="请输入模拟名称"
              :rules="[{ required: true, message: '请输入模拟名称' }]"
            />
          </div>
          <p class="wrapper-label">初始化资金</p>
          <div class="c-l-right">
            <van-field v-model="capital" type="digit" label="" />
            <span class="unit">元</span>
          </div>

          <p class="wrapper-label">选定持仓周期</p>
          <div class="c-l-right">
            <p class="imitation-select" @click="showPeriod = true">
              {{ periodValue }}
              <van-icon name="arrow-down" class="arrow-down" />
            </p>
          </div>

          <van-action-sheet v-model="showPeriod">
            <van-picker
              title="选定持仓周期"
              show-toolbar
              :columns="columnsPeriod"
              @confirm="onConfirmPeriod"
              @cancel="onCancelPeriod"
              :default-index="cgzq_defaultIndex"
            />
          </van-action-sheet>

          <div class="wrapper-btn">
            <van-button
              class="left"
              @click="
                showoVerlay = false;
                getClientFun();
              "
              native-type="button"
              >取消</van-button
            >
            <van-button
              type="info"
              class="right"
              :loading="loadingMn"
              loading-text="开启中..."
              native-type="submit"
              >开启模拟交易
            </van-button>
          </div>
        </van-form>
      </div>
    </van-overlay>

    <takeOut
      :show="takeShow"
      :name="takeName"
      :btnText="takeBtnName"
      type="openMn"
      @cancelBasis="cancelBasis"
      @linkGo="linkGo"
    ></takeOut>
  </div>
</template>

<script>
import { factorArrCheckoutFun } from '@/utils/commonAPI';
import { mapMutations } from 'vuex';
import mixin from '@/mixins/index.js';
import { judgeColor, toFixedNum, dateFormat,compareVersions } from '@/utils/format';
import { getMyHcInfo, topMyHcInfo, delMyDyzHcById } from '@/api/my.js';
import { mockpanelOpen } from '@/api/create';
import { getClientRedis } from '@/api/index.js';

export default {
  name: 'Personal_Hc',
  mixins: [mixin],
  data() {
    return {
      checkedID: 0,
      tabs: ['多因子策略回测', '量化交易策略回测'],
      show: false,
      actions: [{ name: '置顶' }, { name: '删除' }],
      countData: 0,
      listData: [],
      description: '数据加载中',
      h_id: null,
      listIndex: 0,
      showoVerlay: false,
      loadingMn: false,
      columnsPeriod: [],
      mnjyName: '',
      showPeriod: false,
      periodValue: '',
      capital: 100000, //初始化资金
      cgzq_defaultIndex: 0, //持股周期select默认值
      f_id_arr: '',
      takeShow: false,
      takeName: '',
      takeBtnName: '',
      isShowKd: false
    };
  },
  //计算属性
  computed: {
    checkedYzList: function () {
      return this.$store.state.checkedYzList; // 获取全局状态
    },
    Obj: function () {
      return this.$store.state.Obj; // 获取全局状态
    },
    contentNavBar: function () {
      return this.$store.state.contentNavBar; // 获取全局状态
    },
    publicHcID: function () {
      return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
    }
  },

  watch: {},
  components: {},
  filters: {},
  created() {
    // this.getClientFun();
  },
  watch: {
    checkedID: function (i) {
      const cardListElement = this.$refs.cardList;
      if (cardListElement) {
        cardListElement.scrollTop = 0;
      }
      if (i) {
        this.actions = [{ name: '置顶' }, { name: '开启模拟交易' }, { name: '删除' }];
      } else {
        this.actions = [{ name: '置顶' }, { name: '删除' }];
      }
    }
  },
  mounted() {
    // this.checkedID = Number(this.getUrlQuery('smallTab'))
    //   ? Number(this.getUrlQuery('smallTab'))
    //   : 0;
    this.checkedID = this.$store.state.smallTab ? this.$store.state.smallTab : 0;

    this.getMyHcInfoFun();
  },
  methods: {
    judgeColor,
    toFixedNum,
    dateFormat,
    compareVersions,
    ...mapMutations(['resetState']),

    //查询是否显示扣豆
    getClientFun() {
      var _this = this;
      getClientRedis({})
        .then((res) => {
          if (res.err === 200) {
            var data = JSON.parse(res.data);
            _this.setLocalData(data);
            if (data.openMn === 'true') {
              _this.isShowKd = false;
            } else {
              _this.isShowKd = true;
            }
          } else {
            _this.isShowKd = true;
            _this.setLocalData();
          }
        })
        .catch(() => {
          _this.isShowKd = true;
          _this.setLocalData();
        });
    },
    handleClickTabs: function (index) {
      if (this.checkedID !== index) {
        // this.$router.push(
        //   `${this.$route.path}?token=${this.getUrlQuery('token')}&tab=hc&smallTab=${index}`
        // );
        this.$store.commit('setSmallTab', index);
        this.checkedID = index;
        this.getMyHcInfoFun();
      }
    },
    convertToCommaSeparatedArray: function (str) {
      const arr = str.split('');
      return arr.join(',');
    },

    //手动调整数组的顺序放在第一个
    moveObjectToFirst: function (hId, array) {
      array.sort((a, b) => {
        if (a.h_id === hId) {
          return -1; // 将匹配的对象放在数组的前面
        } else if (b.h_id === hId) {
          return 1; // 将匹配的对象放在数组的前面
        } else {
          return 0; // 保持原有的顺序
        }
      });
    },

    //手动调整数组的顺序放在最后一个
    moveObjectToLast: function (hId, array) {
      const index = array.findIndex((obj) => obj.h_id === hId);
      if (index !== -1) {
        const [object] = array.splice(index, 1);
        array.push(object);
      }
    },

    //获取列表数据
    getMyHcInfoFun: function () {
      this.$toast.loading({
        message: '加载中...',
        overlay: true,
        duration: 0
      });
      this.description = '数据加载中';
      getMyHcInfo({
        type: this.checkedID ? 'lhjy' : 'dyz', //类型:  dyz:多因子回测 lhjy:量化回测
        start: 1,
        count: 200,
        type_info: compareVersions(this.$route.query.version , 9.69)  ? 0 : 1 //0全部  1A股 2ETF
      })
        .then((res) => {
          this.$toast.clear();
          if (res.err === 200) {
            this.countData = res.data.countData;
            this.listData = res.data.listData;
          } else {
            this.countData = 0;
            this.listData = [];
            this.description = '暂无数据';
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    findIndexFromList: function (value, list) {
      const valueString = value + '天';
      for (let i = 0; i < list.length; i++) {
        if (list[i] === valueString) {
          return i;
        }
      }

      return 0; // 如果未找到匹配值，则返回 0 表示未找到
    },

    //点击三个点
    handleCliakActionSheet: function (
      h_id,
      index,
      sort_top,
      mn_status,
      chigu_cycle,
      MaxYearCycle,
      sortKind
    ) {
      if (sort_top) {
        this.actions[0].name = '取消置顶';
      } else {
        this.actions[0].name = '置顶';
      }

      if (mn_status === 0 && sort_top) {
        this.actions = [{ name: '取消置顶' }, { name: '开启模拟交易' }, { name: '删除' }];
      } else if (mn_status === 0 && !sort_top) {
        this.actions = [{ name: '置顶' }, { name: '开启模拟交易' }, { name: '删除' }];
      } else if (mn_status === 1 && sort_top) {
        this.actions = [{ name: '取消置顶' }];
      } else if (mn_status === 1 && !sort_top) {
        this.actions = [{ name: '置顶' }];
      }

      console.log(mn_status, sort_top, this.actions, '=-=-=-');

      if (this.checkedID && mn_status === 0) {
        var result = chigu_cycle.split(',').map((item) => `${item}天`);
        this.columnsPeriod = result;
        this.cgzq_defaultIndex = this.findIndexFromList(MaxYearCycle, result);
        this.periodValue = MaxYearCycle + '天';

        if (sortKind < 100000) {
          this.capital = 100000;
        } else {
          this.capital = sortKind;
        }
      }
      this.h_id = h_id;
      this.listIndex = index;
      this.show = true;
    },

    //删除 数组里面 id相等的 对象
    deleteObjectByProperty: function (propertyName, propertyValue, arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][propertyName] === propertyValue) {
          arr.splice(i, 1);
          i--;
        }
      }
    },

    //删除
    delMyDyzHcByIdFun: function () {
      let _this = this;
      _this.$toast.loading({
        message: '删除中...',
        overlay: true,
        duration: 0
      });

      let obj = {
        h_id: _this.h_id
      };

      delMyDyzHcById(obj)
        .then((res) => {
          _this.$toast(res.msg);
          if (res.err == 200) {
            // _this.f_id_arr = res.data.condition.f_id_arr;
            _this.deleteObjectByProperty('h_id', _this.h_id, _this.listData);
            _this.countData--;
          }
        })
        .catch((err) => {
          _this.$toast(err);
        });
    },

    //点击取消或置顶把对应的置顶状态取反
    toggleSortTopById: function (hId, array) {
      const object = array.find((obj) => obj.h_id === hId);
      if (object) {
        object.sort_top = object.sort_top === 0 ? 1 : 0;
      }
    },

    //置顶
    topMyHcInfoFun: function () {
      let _this = this;

      let obj = {
        h_id: _this.h_id
      };

      topMyHcInfo(obj)
        .then((res) => {
          _this.$toast(res.msg);
          if (res.err == 200) {
            if (_this.listData[_this.listIndex].sort_top) {
              _this.moveObjectToLast(this.h_id, _this.listData);
            } else {
              _this.moveObjectToFirst(this.h_id, _this.listData);
            }

            _this.toggleSortTopById(this.h_id, _this.listData);
          }
        })
        .catch((err) => {
          _this.$toast(err);
        });
    },

    onCancel: function () {
      this.mnjyName = '';
    },
    onSelect: function (i) {
      if (i.name === '置顶' || i.name === '取消置顶') {
        this.topMyHcInfoFun();
      } else if (i.name === '删除') {
        this.delMyDyzHcByIdFun();
      } else if (i.name === '开启模拟交易') {
        let msg = [];
        factorArrCheckoutFun(this.f_id_arr).then((d) => {
          if (d.length > 0) {
            d.forEach((i) => {
              if (i.BacktestType == 2 || i.BacktestType == 3) {
                msg.push(i.Name + '(不可回测)');
              } else if (i.BacktestType == 10) {
                msg.push(i.Name + '(已删除)');
              }
            });

            this.$toast('开启模拟交易失败:' + msg.toString());
          }
          //  else {
          //   if (this.isShowKd) {
          //     this.takeName = '每次开启模拟交易需消耗 2个慧豆';
          //     this.takeBtnName = '继续开启';
          //     this.takeShow = true;
          //     return false;
          //   }
          //   this.showoVerlay = true;
          // }
        });
      }
    },

    //持仓周期
    onConfirmPeriod: function (value, index) {
      this.showPeriod = false;
      this.periodValue = value;
    },

    onCancelPeriod: function (picker, value, index) {
      this.showPeriod = false;
    },

    // 跳转模拟详情
    goMnDetail: function (item) {
      // this.$router.push(
      //   `${this.$route.path}?token=${this.getUrlQuery('token')}&tab=hc&smallTab=${this.checkedID}`
      // );
      this.$router.push({
        path: '/mnDetail',
        name: 'mnDetail',
        query: {
          token: this.$route.query.token || '',
          zj_id: this.Obj.apiData.condition.zj_id,
          themeStyleVs: this.$route.query.themeStyleVs || 0,
          version: this.$route.query.version || ''
        }
      });
    },

    cancelBasis: function () {
      this.takeShow = false;
    },

    linkGo: function () {
      this.takeShow = false;
      this.showoVerlay = true;
    },

    //弹框点击开启模拟交易按钮
    saveMnjy: function () {
      if (this.capital < 100000 || this.capital === '') {
        this.$toast('初始化资金不能小于10万');
        return false;
      } else if (this.capital > 10000000) {
        this.$toast('初始化资金不能大于1000万');
        return false;
      } else if (this.capital.toString().startsWith('0')) {
        this.$toast('初始化资金输入格式不正确');
        return false;
      }

      this.mockpanelOpenFun();
    },

    //提交开启模拟交易
    mockpanelOpenFun: function () {
      let _this = this;
      _this.loadingMn = true;

      var params = {
        name: _this.mnjyName, //模拟盘名称
        cycle: _this.periodValue.replace('天', ''), // 选择的持股周期
        startMoney: _this.capital, //初始资金
        h_id: _this.h_id || _this.publicHcID //选中的回测ID
      };
      return mockpanelOpen(params)
        .then((res) => {
          _this.loadingMn = false;
          _this.$toast(res.msg);
          if (res.err === 200) {
            _this.showoVerlay = false;

            _this.$router.push({
              path: '/mnDetail',
              name: 'mnDetail',
              query: {
                token: _this.$route.query.token || '',
                zj_id: res.data.zj_id,
                themeStyleVs: _this.$route.query.themeStyleVs || 0,
                version: _this.$route.query.version || ''
              }
            });

            setTimeout(() => {
              _this.resetState(); //重置部分vuex
            }, 500);
          } else if (res.err === 304) {
            window.location.href = window.config.hdTips;
          }
        })
        .catch((err) => {
          _this.loadingMn = false;
          _this.$toast(err);
        });
    },

    //跳转详情
    goDetails: async function (h_id) {
      if (this.checkedID === 0) {
        // this.$router.push(
        //   `${this.$route.path}?token=${this.getUrlQuery('token')}&tab=hc&smallTab=${this.checkedID}`
        // );
        this.$router.push({
          path: '/dyz-details',
          name: 'Dyz-details',
          query: {
            source: 'dyzcl', //用来标注是从多因子还是量化过去的
            token: this.$route.query.token || '',
            h_id: h_id,
            mySource: 'myDyzHc', //用来标注是从个人中心过去的
            themeStyleVs: this.$route.query.themeStyleVs || 0,
            version: this.$route.query.version
          }
        });
      } else if (this.checkedID === 1) {
        // this.$router.push(
        //   `${this.$route.path}?token=${this.getUrlQuery('token')}&tab=hc&smallTab=${this.checkedID}`
        // );
        this.$router.push({
          path: '/lhhc-details',
          name: 'Lhhc-details',
          query: {
            source: 'lhcl', //用来标注是从多因子还是量化过去的
            token: this.$route.query.token || '',
            h_id: h_id,
            mySource: 'myLhHc', //用来标注是从个人中心过去的
            themeStyleVs: this.$route.query.themeStyleVs || 0,
            version: this.$route.query.version
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.isNoMoreValue {
  color: #969799;
  font-size: 0.37333rem;
  line-height: 1.33333rem;
  text-align: center;
}
.personal-center_hc {
  .nav_tabs {
    display: flex;
    align-items: center;
    padding: 12px 12px 0;
    li {
      padding: 4px 16px;
      border-radius: 2px;
      background: #fff;
      margin-right: 8px;
      font-size: 12px;
      font-weight: 400;
    }
    .checkedClass {
      background: #286df7;
      color: #fff;
    }
  }
  .census {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    margin: 8px 0;
    padding: 0 12px;
  }
  .hc_card {
    height: calc(100vh - 190px);
    overflow-y: auto;
    padding: 0 12px 12px;
    -webkit-overflow-scrolling: touch;
    li {
      padding: 12px;
      border-radius: 8px;
      box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
      margin-bottom: 8px;
      background: #fff;
      position: relative;
      .zdtype {
        position: absolute;
        width: 10px;
        height: 10px;
        top: 6px;
        left: 6px;
      }

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .top_left {
          color: #222;
          font-size: 16px;
          font-weight: 600;
          .underway {
            padding: 1px 4px;
            border-radius: 2px;
            background: linear-gradient(93deg, #286df7 0%, #7ea9ff 100%);
            color: #fff;
            font-size: 12px;
          }
        }
        .dian {
          font-size: 20px;
        }
      }
      .residue {
        color: #999;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        margin: 11px 0 8px 0;
        display: flex;
        align-items: center;
        .num {
          flex-shrink: 0;
          margin-left: 4px;
        }
      }
      .card {
        line-height: 20px;
        .block {
          padding: 12px 16px;
          border-radius: 4px;
          background: #f7f8fa;
          text-align: center;
          height: 78px;
          p {
            text-align: center;
            height: 20px;
            word-wrap: break-word;
            word-break: normal;
          }
          .b_p1 {
            color: #555;
            font-size: 12px;
            font-weight: 500;
          }
          .b_p2 {
            color: #555;
            font-size: 12px;
            font-weight: 600;
          }
          .b_p3 {
            color: #999;
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
    }
  }
  .bottom_time {
    line-height: 25px;
    margin-top: 8px;
    .label {
      color: #999;
      font-size: 12px;
      font-weight: 400;
    }
    .content {
      text-align: right;
      color: #555;
      font-size: 12px;
      font-weight: 400;
    }
  }
}

::v-deep {
  .van-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    .wrapper-overlay {
      width: 285px;
      border-radius: 10px;
      padding: 16px;
      background: #fff;
      .wrapper-title {
        text-align: center;
        font-size: 16px;
        color: #222;
        margin-bottom: 16px;
      }
      .wrapper-label {
        font-size: 14px;
        color: #555;
        margin-bottom: 4px;
      }
      .c-l-right {
        position: relative;
        display: flex;
        align-items: center;
        .van-cell {
          padding: 8px;
        }

        .unit {
          position: absolute;
          top: 11px;
          right: 8px;
          background: #fff;
        }
        .imitation-select {
          margin-bottom: 17px;
          width: 100%;
          position: relative;
          border-radius: 4px;
          height: 38px;
          display: flex;
          align-items: center;
          border: 0.5px solid #e5e5e5;
          padding: 0 8px;
          .arrow-down {
            position: absolute;
            font-size: 15px;
            right: 7px;
            top: 11px;
          }
        }
        .mrsj-button {
          width: 120px;
          height: 32px;
          display: flex;
          align-items: center;
          padding: 0 22px 0 12px;
          border-radius: 6px;
          background: #f7f7fc;
          color: #999;
          font-size: 14px;
        }
        .text {
          flex-shrink: 0;
        }
      }
      .name {
        position: relative;
        .van-cell {
          height: 38px;
          padding: 8px 10px;
        }
        .van-field__word-limit {
          position: absolute;
          right: 7px;
          top: 0px;
        }
      }
      .van-cell {
        border: 0.5px solid #e5e5e5;
        border-radius: 4px;
        margin-bottom: 16px;
        &::after {
          border: none;
        }
      }
      .van-field__control {
        &::placeholder {
          font-size: 14px;
        }
      }
    }
    .wrapper-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      button {
        border: none;
        height: 36px;
        font-size: 14px;
        border-radius: 6px;
        width: 50%;
      }
      .left {
        background: #f5f5f6;
        color: #222;
        margin-right: 12px;
      }
      .rught {
        background: #286df7;
        color: #fff;
        margin-left: 12px;
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .nav_tabs {
    li {
      background: #1d202d;
      color: #e4e9fe;
    }
  }
  .census {
    color: #aab9d1 !important;
  }
  .hc_card {
    li {
      background: #191a24;
    }
    .block {
      background: #1d202d !important;
      .b_p1 {
        color: #aab9d1 !important;
      }
      .b_p3 {
        color: #6b7687 !important;
      }
    }
    .top {
      .top_left {
        color: #e4e9fe !important;
      }
      .dian {
        color: #e4e9fe !important;
      }
    }
    .residue,
    .label,
    .content {
      color: #aab9d1 !important;
    }
  }
  .van-action-sheet__item,
  .van-action-sheet__cancel {
    background: #1d202d;
  }
  .van-action-sheet__item {
    border-bottom: 1px solid #333743;
  }
  .van-action-sheet__gap {
    display: none;
  }
  .van-action-sheet__name,
  .van-action-sheet__cancel {
    color: #aab9d1;
  }
}
</style>
